import { NodumOrder } from "~/routes/api.createNodumOrder";
import { FetchWrapperError } from "./types/errors/fetchWrapperError";
import { UpdateParcelError } from "./types/errors/updateParcelError";

export function isFetchWrapperError(obj: any): obj is FetchWrapperError {
    return 'code' in obj
}

export function isParcelUpdateError(obj: any): obj is UpdateParcelError {
    return 'errorID' in obj
}

export function isNodumError(obj: any): obj is NodumOrder {
    return 'error' in obj && obj.error !== null
}